export default __webpack_public_path__ + "static/media/no-connection.65b405a6.gif";